import { render } from "./VerticalNav.vue?vue&type=template&id=0f32ebe0"
import script from "./VerticalNav.vue?vue&type=script&lang=js"
export * from "./VerticalNav.vue?vue&type=script&lang=js"

import "./VerticalNav.vue?vue&type=style&index=0&id=0f32ebe0&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__